/* Dikey video bölümü (sections/video-stories.liquid)

   İşi: dikey videoları YALNIZ ekranda görünürken sessizce oynatmak, ekrandan
   çıkınca duraklatmak (pil ve veri), oynat/duraklat ile ses düğmesini çalıştırmak.

   Kurallar:
   · Hareket azaltma (prefers-reduced-motion) açıkken otomatik oynatma yok;
     kapak görseli durur, ortadaki oynat düğmesi ister.
   · Kullanıcı elle duraklattıysa (held) kaydırma onu tekrar başlatmaz.
   · Durum düğmenin ADIYLA bildirilir (aria-pressed kullanılmaz).
   · Video yüklenemezse düğmeler kaldırılır, kapak görselinde kalınır; konsola
     hiçbir şey yazılmaz.
   · Düğmeler CSS'te gizlidir, bu dosya .is-js sınıfını ekleyene kadar görünmezler:
     JS yoksa ölü düğme kalmaz. */
(function () {
  'use strict';

  /* Bölüm sayfada iki kez varsa script de iki kez gelir; bir kez çalışması yeter */
  if (window.__dedeVst) return;
  window.__dedeVst = 1;

  var D = document;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var stages = [];
  var io = null;

  function arr(list) { return Array.prototype.slice.call(list); }
  function still() { return !!(mq && mq.matches); }
  function name(btn, text) { if (btn) btn.setAttribute('aria-label', text); }

  function fail(st) {
    st.failed = true;
    st.el.classList.add('is-failed');
    st.el.classList.remove('is-playing');
    st.el.classList.remove('is-loud');
  }

  function start(st) {
    if (st.failed) return;
    var p;
    try { p = st.video.play(); } catch (e) { return; }
    /* Oynatma engellenirse (tarayıcı izni, ağ) sessizce kapakta kalırız */
    if (p && p.catch) p.catch(function () {});
  }

  function stop(st) {
    try { st.video.pause(); } catch (e) {}
  }

  function sync(st) {
    var on = !st.video.paused && !st.video.ended;
    st.el.classList.toggle('is-playing', on);
    name(st.play, on ? 'Videoyu duraklat' : 'Videoyu oynat');
  }

  function syncSound(st) {
    var loud = !st.video.muted;
    st.el.classList.toggle('is-loud', loud);
    name(st.sound, loud ? 'Videonun sesini kapat' : 'Videonun sesini aç');
  }

  /* Görünürlük: %30'u ekrandaysa oynar, altına düşerse durur */
  function observer() {
    if (io || !window.IntersectionObserver) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var st = entry.target.__vst;
        if (!st) return;
        st.seen = entry.isIntersecting && entry.intersectionRatio >= 0.3;
        if (st.seen) {
          if (!st.held && !still() && !D.hidden) start(st);
        } else {
          stop(st);
        }
      });
    }, { threshold: [0, 0.3, 0.6] });
    return io;
  }

  function watch(st) {
    var o = observer();
    if (o) { o.observe(st.el); return; }
    /* IntersectionObserver yoksa (çok eski tarayıcı) doğrudan oynat */
    st.seen = true;
    if (!still()) start(st);
  }

  function make(el) {
    if (el.__vst) return;
    var v = el.querySelector('[data-vst-video]');
    if (!v) return;

    var st = {
      el: el,
      video: v,
      play: el.querySelector('[data-vst-play]'),
      sound: el.querySelector('[data-vst-sound]'),
      held: false,
      seen: false,
      failed: false
    };
    el.__vst = st;
    stages.push(st);

    v.muted = true;
    if (v.error) { fail(st); return; }
    v.addEventListener('error', function () { fail(st); });
    v.addEventListener('playing', function () { sync(st); });
    v.addEventListener('pause', function () { sync(st); });
    v.addEventListener('ended', function () { sync(st); });

    if (st.play) {
      st.play.addEventListener('click', function () {
        if (v.paused || v.ended) {
          st.held = false;
          start(st);
        } else {
          st.held = true;
          stop(st);
        }
      });
    }

    if (st.sound) {
      st.sound.addEventListener('click', function () {
        v.muted = !v.muted;
        syncSound(st);
        /* Sesi açan kişi videoyu da izlemek istiyordur */
        if (!v.muted && (v.paused || v.ended)) {
          st.held = false;
          start(st);
        }
      });
    }

    sync(st);
    syncSound(st);
    watch(st);
  }

  function setup(root) {
    if (root.__vstReady) return;
    root.__vstReady = 1;
    root.classList.add('is-js');
    arr(root.querySelectorAll('[data-vst-stage]')).forEach(make);
  }

  function scan(scope) {
    var node = scope || D;
    if (node.matches && node.matches('[data-vst]')) setup(node);
    if (node.querySelectorAll) arr(node.querySelectorAll('[data-vst]')).forEach(setup);
  }

  function refresh() {
    stages.forEach(function (st) {
      if (D.hidden || still()) stop(st);
      else if (st.seen && !st.held) start(st);
    });
  }

  scan(D);

  /* Sekme arkaya düşerse videolar boşa oynamasın */
  D.addEventListener('visibilitychange', refresh);

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', refresh);
    else if (mq.addListener) mq.addListener(refresh);
  }

  /* ---- tema düzenleyicisi ---- */
  D.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  D.addEventListener('shopify:section:unload', function (e) {
    arr(e.target.querySelectorAll('[data-vst-stage]')).forEach(function (el) {
      var st = el.__vst;
      if (!st) return;
      stop(st);
      if (io) io.unobserve(el);
      var i = stages.indexOf(st);
      if (i > -1) stages.splice(i, 1);
      el.__vst = null;
    });
  });

  /* Blok seçilince o video öne çıksın */
  D.addEventListener('shopify:block:select', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-vst-stage]') : null;
    var st = el && el.__vst;
    if (st && !still()) {
      st.held = false;
      start(st);
    }
  });
})();
